import React, { Component } from "react";
import Grid from "../../lib/components/grid";
import { GridColumns } from "./marketsgridsetup";

type Props = {
  loading: boolean;
  data: any[];
  handleEdit(id: number): void;
  handleRemove(id: number): void;
};

class MarketsGrid extends Component<Props, {}> {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Grid
        loading={this.props.loading}
        data={this.props.data}
        GridColumns={(data, filters, columnArrangement, columnsWidth) =>
          GridColumns(data, filters, columnArrangement, columnsWidth, this.props.handleRemove, this.props.handleEdit)
        }
        clearFilters={"pricecomparisonmarkets"}
      />
    );
  }
}

export default MarketsGrid;
